/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Donation } from './Donation';
import {
    DonationFromJSON,
    DonationFromJSONTyped,
    DonationToJSON,
    DonationToJSONTyped,
} from './Donation';

/**
 * 
 * @export
 * @interface ActiveGoodHabitVoucherResponse
 */
export interface ActiveGoodHabitVoucherResponse {
    /**
     * 
     * @type {Donation}
     * @memberof ActiveGoodHabitVoucherResponse
     */
    donation: Donation;
    /**
     * Remaining price in cents for voucher. For example if voucher on 900 Kc has 3 donations and this is the second one, remaining amount will be 30000 cents (300 kc). If the voucher is only for 1 month, amount will be null.
     * @type {number}
     * @memberof ActiveGoodHabitVoucherResponse
     */
    remainingAmountInCents: number | null;
}

/**
 * Check if a given object implements the ActiveGoodHabitVoucherResponse interface.
 */
export function instanceOfActiveGoodHabitVoucherResponse(value: object): value is ActiveGoodHabitVoucherResponse {
    if (!('donation' in value) || value['donation'] === undefined) return false;
    if (!('remainingAmountInCents' in value) || value['remainingAmountInCents'] === undefined) return false;
    return true;
}

export function ActiveGoodHabitVoucherResponseFromJSON(json: any): ActiveGoodHabitVoucherResponse {
    return ActiveGoodHabitVoucherResponseFromJSONTyped(json, false);
}

export function ActiveGoodHabitVoucherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveGoodHabitVoucherResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'donation': DonationFromJSON(json['donation']),
        'remainingAmountInCents': json['remainingAmountInCents'],
    };
}

export function ActiveGoodHabitVoucherResponseToJSON(json: any): ActiveGoodHabitVoucherResponse {
    return ActiveGoodHabitVoucherResponseToJSONTyped(json, false);
}

export function ActiveGoodHabitVoucherResponseToJSONTyped(value?: ActiveGoodHabitVoucherResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'donation': DonationToJSON(value['donation']),
        'remainingAmountInCents': value['remainingAmountInCents'],
    };
}

